import React, { useState } from "react";
import { Button, MultiLevelBuilder } from "../../../../../../components";
import { useNavigate, useLocation } from "react-router-dom";
import buildCampaignConfig from "../../../../../../components/MultiLevelBuilder/campaignConfig";
import ScheduleModal from "./modals/ScheduleModal";
import Drawer from "../../../../../../components/Modal/Drawer";
import TemplatePreviewModel from "./modals/TemplatePreviewModel";

const CreateCampaign = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedJobUiid } = location.state || {};

  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [isTemplateDrawer, setIsTemplateDrawer] = useState(false);
  const [selectedStepId, setSelectedStepId] = useState(null);
  const [availableTemplates, setAvailableTemplates] = useState([]);
  const [campaignType, setCampaignType] = useState("");
  const [clickedView, setClickedView] = useState("");
  const [addTemplateCallback, setAddTemplateCallback] = useState(null);

  const campaignConfig = buildCampaignConfig();

  const handleViewClick = (stepId, templates, type, clickedTemplate) => {
    setSelectedStepId(stepId);
    setAvailableTemplates(templates);
    setCampaignType(type);
    setClickedView(clickedTemplate);
    setIsTemplateDrawer(true);
  };

  const handleUseTemplate = (templateValue, stepId) => {
    if (addTemplateCallback) {
      addTemplateCallback(stepId, templateValue);
    }
    setIsTemplateDrawer(false);
  };

  const handleTemplateAdd = (callback) => {
    setAddTemplateCallback(() => callback);
  };

  return (
    <div>
      <Button
        title={"Create Campaign"}
        color="black"
        variant="text"
        icon={"west"}
        // onClick={() => navigate("/ats/jobs/job-details#job-campaign")}
        onClick={() => {
            sessionStorage.setItem("selectedJobUiid", selectedJobUiid);
            navigate("/ats/jobs/job-details?job-details=job-campaign") 
          }
        }
        className="font-semibold !px-1"
      />

      <MultiLevelBuilder
        config={campaignConfig}
        onSchedule={() => setShowScheduleModal(true)}
        onViewClick={handleViewClick}
        onTemplateAdd={handleTemplateAdd}
      />

      <ScheduleModal
        isOpen={showScheduleModal}
        onClose={() => setShowScheduleModal(false)}
      />

      <Drawer
        isOpen={isTemplateDrawer}
        onClose={() => setIsTemplateDrawer(false)}
        position="right"
        width="w-[50%]"
        title="Template Preview"
        titleColor="primary"
        closeOnOutsideClick
        zIndex={54}
      >
        <TemplatePreviewModel
          stepId={selectedStepId}
          availableTemplates={availableTemplates}
          campaignType={campaignType}
          clickedView={clickedView}
          onUseTemplate={handleUseTemplate}
          onClose={() => setIsTemplateDrawer(false)}
        />
      </Drawer>
    </div>
  );
};

export default CreateCampaign;
